module.exports = __webpack_public_path__ + "img/room03_pista.31a14014.png";